import React, { useCallback, useState } from 'react';
import { func } from 'prop-types';
import { Tab, Tabs } from '@one-thd/sui-atomic-components';

const consumerTypeManifest = ['Residential', 'Commercial'];

export const RebateConsumerTabs = ({ onChange }) => {
  const [index, setIndex] = useState(0);

  const handleChange = useCallback((event, newIndex) => {
    event.preventDefault();
    event.stopPropagation();
    const consumerType = consumerTypeManifest[newIndex]?.toLocaleLowerCase();
    setIndex(newIndex);
    onChange(consumerType);
  }, [onChange]);

  return (
    <div className="sui-px-2 sui-bg-primary">
      <Tabs value={index} onChange={handleChange}>
        {consumerTypeManifest.map((consumerType, consumerTypeIndex) => (
          <Tab
            key={consumerTypeIndex}
            label={consumerType}
          />
        ))}
      </Tabs>
    </div>
  );
};

RebateConsumerTabs.propTypes = {
  onChange: func.isRequired
};

RebateConsumerTabs.defaultProps = {};

RebateConsumerTabs.displayName = 'RebateConsumerTabs';
